import { lazy } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../__business/components/toolcategories/Index';
import { RenderAPI } from '../../__business/components/global/RenderAPI';
import { Switching } from '../../__business/components/swtiching/Index'
import { Settings } from '../../__business/components/settings/Index';

let view = VM();
const Navigation = lazy(() => import(`../../__business/components/layouts/navigations${view}/Index`))
// const Home = lazy(() => import (`../../__business/components/home${view}/Index`))
const Library = lazy(() => import (`../../__business/components/library${view}/Index`))
const Report = lazy(() => import (`../../__business/components/report${view}/Index`))
const Approver = lazy(() => import (`../../__business/components/approver${view}/Index`))
const PublicationForm = lazy(() => import (`../../__business/components/library/publication/form/Index`))
const BulletinForm = lazy(() => import (`../../__business/components/library/bulletin/form/Index`))
const PublicationReview = lazy(() => import(`../../__business/components/approver/publication/review/Index`))
const BulletinReview = lazy(() => import(`../../__business/components/approver/bulletin/review/Index`))
const Profile = lazy(() => import(`../../__business/components/profile${view}/Index`))
const Inquiries = lazy(() => import(`../../__business/components/inquiries${view}/Index`))
const Onboarding = lazy(() => import(`../../__business/components/personalization/onboarding${view}/Index`))

export const WebRoute = () => {
    const location = useLocation().pathname;
    
    return (
        <Switch>
            {/* HOME */}
            <Route exact path="/biz">
                <Redirect to="/biz/library?sub=publication&tag=all" />
            </Route>
            {/* <Route exact path="/biz" render={props=>(Render(Home, props, location))}/> */}
            <Route exact path="/biz/switching" render={props=><Switching/>} />
            <Route exact path="/biz/more" render={props=>(Render(Settings, props, location))} />
            <Route exact path="/biz/tool-categories/:params" render={props=>(Render(ToolCategories, props, location))} />

            
            {/* Library */}
            <Route exact path="/biz/library" render={props=>(Render(Library, props, location))}/>
            <Route exact path="/biz/library/publication-form" render={props=>(Render(PublicationForm, props, location))} />
            <Route exact path="/biz/bulletin-form" render={props => (Render(BulletinForm, props, location))}/>

            {/* Approver */}
            <Route exact path="/biz/approver" render={props=>(Render(Approver, props, location))} />
            <Route exact path="/biz/approver/review/publication" render={props=>(Render(PublicationReview, props, location))} />
            <Route exact path="/biz/approver/review/bulletin" render={props=>(Render(BulletinReview, props, location))} />

            {/* Report */}
            <Route exact path="/biz/report" render={props=>(Render(Report, props, location))}/>

            {/* Profile */}
            <Route exact path="/biz/profile" render={props=>(Render(Profile, props, location))}/>

            {/* Inquiries */}
            <Route exact path="/biz/inquiries" render={props=>(Render(Inquiries, props, location))}/>

            {/* Onboarding */}
            <Route exact path="/biz/onboarding" render={props=>(Render(Onboarding, props, location))}/>

            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const Render = (Component, props, location) => (
    <>
        {view === '' ? (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex">
                    <Box height="100%">
                        {
                            (location !== '/biz/profiling') &&
                            (location !==  '/biz/library/form') &&
                            (location !==  '/biz/library/publication-form') &&
                            (location !==  '/biz/library/publication-form-v3') &&
                            (location !== '/biz/bulletin-form') &&
                            (location.split("/")[3] !== 'review') &&
                            (location !== '/biz/onboarding' ) &&
                            (<Navigation side={1} />) 
                        }
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" height="100%">
                        {
                            (location !==  '/biz/library/form') &&
                            (location !==  '/biz/library/publication-form') &&
                            (location !==  '/biz/library/publication-form-v3') &&
                            (location !== '/biz/bulletin-form') &&
                            (location.split("/")[3] !== 'review') &&
                            (location !== '/biz/onboarding' ) &&
                            <Navigation side={0} />
                        }
                        <Box height="100%" className="overflowY noScrollcss">
                            <Component {...props} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        ) : (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex" flexDirection="column">
                    {(location !== '/biz/profiling' && location !== '/biz/more') && (
                        <Box minHeight={location === '/biz' ? '92px' : '40px'}>
                            <Navigation side={0} />
                        </Box>
                    )}
                    <Box height="100%" width="100%" className="overflowY noScrollcss"><Component {...props} /></Box>
                    {(location !== '/profile' && location !== '/biz/profiling') &&
                        <Box minHeight="54px">
                            <Navigation side={2} />
                        </Box>
                    } 
                </Box>
            </Box>
        )}
        <RenderAPI/>
    </>
)